import styled from "styled-components";
import { Link } from "react-router-dom";

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  min-height: 33%;
  padding: 25px;
  background-color: #fff;
  border-radius: 21px;
  overflow: hidden;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 3px 6px #0000005a;

  @media screen and (max-width: 768px) {
    align-items: center;
    width: 96%;
  }
`;

export const LoginTitle = styled.span`
  text-align: center;
  letter-spacing: 0px;
  font: normal normal bold 26px/40px Mangueira;
  color: #000000;
  @media (max-width: 768px) {
    text-align: left;
  }
`;

export const SignInButton = styled.button`
  font: normal normal 600 16px/12px Mangueira;
  letter-spacing: 0px;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  width: 100%;
  height: 45px;
  background-color: ${(props) => (props.outline ? "transparent" : "#000FFF")};
  border-radius: 10px;
  color: ${(props) => (props.outline ? "#000FFF" : "#ffffff")};
  text-align: center;
  border: ${(props) => (props.outline ? "2px solid #000FFF" : "0")};
  overflow: hidden;
  box-shadow: ${(props) => (props.outline ? "0px 3px 8px #00000040" : "0px 3px 8px #00000059")};
  border-radius: ${(props) => (props.outline ? "8px" : "10px")};
  transition: 0.5s;
  &:hover {
    filter: brightness(85%);
  }
  img {
    float: left;
    padding-left: 0.7rem;
  }
  span {
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const FirstAccessContainer = styled(Link)`
`;
